import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Privacy() {
	return (
		<main className="min-h-screen bg-white">
			<Helmet>
				<title>プライバシーポリシー | しろぬきや</title>
			</Helmet>
			<header className="border-b border-gray-100 bg-white sticky top-0 z-10">
				<div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-2">
					<Link
						to="/"
						className="flex items-center gap-2 hover:opacity-80 transition"
					>
						<span className="text-2xl">✂️</span>
						<span className="font-bold text-lg text-gray-900">しろぬきや</span>
					</Link>
				</div>
			</header>

			<div className="max-w-3xl mx-auto px-4 py-12">
				<h1 className="text-3xl font-bold text-gray-900 mb-2">
					プライバシーポリシー
				</h1>
				<p className="text-sm text-gray-500 mb-10">最終更新日: 2026年3月15日</p>

				<div className="space-y-8 text-gray-700 leading-relaxed">
					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							1. 収集する情報
						</h2>
						<p className="mb-2">本サービスは以下の情報を収集します。</p>
						<ul className="list-disc list-inside space-y-2">
							<li>
								<strong>アクセス解析データ（匿名）</strong>: Google Tag
								Manager（GTM）およびGoogle Analytics 4（GA4）を使用して、
								ページ閲覧数・滞在時間・流入元・デバイス情報等の匿名統計データを収集します。
								個人を特定できる情報は含まれません。
							</li>
							<li>
								<strong>メールアドレス</strong>:
								マジックリンク認証によるログインおよびライセンス管理の目的で収集します。
								収集したメールアドレスはサービスの提供以外の目的には使用しません。
							</li>
							<li>
								<strong>決済情報</strong>:
								有料プランご利用時、Stripe社が決済に必要な情報を直接収集します。
								当サービスはクレジットカード番号等の決済情報を保持しません。
							</li>
						</ul>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							2. 画像データの取り扱い
						</h2>
						<p>
							本サービスの背景除去処理は<strong>ブラウザ内で完結</strong>
							します。
							アップロードされた画像はお使いの端末上でのみ処理され、サーバーへ送信されることはありません。
							画像データが外部に送信・保存・第三者に提供されることは一切ありません。
						</p>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							3. Cookieの使用
						</h2>
						<p className="mb-2">本サービスは以下の目的でCookieを使用します。</p>
						<ul className="list-disc list-inside space-y-2">
							<li>
								<strong>Google Analytics / GTM</strong>:
								サイトのアクセス解析のための匿名Cookieです。ブラウザの設定から無効化できます。
							</li>
						</ul>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							4. 第三者への情報提供
						</h2>
						<p>
							本サービスは、以下の場合を除き、利用者の情報を第三者に提供しません。
						</p>
						<ul className="list-disc list-inside space-y-2 mt-2">
							<li>
								<strong>Google LLC</strong>: Google Analytics
								4による匿名アクセス解析データの送信（個人特定不可）
							</li>
							<li>
								<strong>Stripe, Inc.</strong>:
								有料プランの決済処理（決済情報はStripeが直接管理）
							</li>
							<li>
								<strong>Resend, Inc.</strong>:
								マジックリンク認証メールの送信のため、メールアドレスを提供します
							</li>
							<li>法令に基づく開示が必要な場合</li>
						</ul>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							5. Stripe決済について
						</h2>
						<p>
							有料プランへのアップグレードにはStripe社の決済システムを使用します。
							クレジットカード情報等の決済情報はStripeが直接処理・管理し、
							当サービスのサーバーには一切保存されません。
							Stripeのプライバシーポリシーについては
							<a
								href="https://stripe.com/jp/privacy"
								target="_blank"
								rel="noopener noreferrer"
								className="text-blue-600 hover:underline ml-1"
							>
								Stripe公式サイト
							</a>
							をご参照ください。
						</p>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							6. お問い合わせ
						</h2>
						<p>
							プライバシーに関するお問い合わせは
							<Link
								to="/contact"
								className="text-blue-600 hover:underline mx-1"
							>
								お問い合わせページ
							</Link>
							よりご連絡ください。
						</p>
					</section>

					<section>
						<h2 className="text-xl font-semibold text-gray-900 mb-3">
							7. ポリシーの変更
						</h2>
						<p>
							本ポリシーは必要に応じて改定することがあります。
							改定後のポリシーは本ページに掲載された時点より効力を持ちます。
						</p>
					</section>
				</div>
			</div>

			<footer className="text-center py-8 text-gray-400 text-sm border-t border-gray-100">
				<p>© 2026 しろぬきや</p>
				<div className="mt-2 flex justify-center gap-4">
					<Link to="/terms" className="hover:text-gray-600 transition">
						利用規約
					</Link>
					<Link to="/privacy" className="hover:text-gray-600 transition">
						プライバシーポリシー
					</Link>
					<Link to="/tokushoho" className="hover:text-gray-600 transition">
						特定商取引法に基づく表記
					</Link>
					<Link to="/contact" className="hover:text-gray-600 transition">
						お問い合わせ
					</Link>
				</div>
			</footer>
		</main>
	);
}
